export { AddToFavoriteFeatureMobile } from './add-to-favorite';
